import React from 'react';
import styled from '@emotion/styled';
import cancelDeletionImage from '../images/cancel-deletion-hourglass.svg';
import { gridSize } from '@atlaskit/theme';

const imgHeight = 150;

const CancelDeletionContainer = styled.div`
  background: url(${cancelDeletionImage}) no-repeat center top;
  background-size: auto ${imgHeight}px;
  padding-top: ${imgHeight + gridSize() * 2}px;
  margin-top: ${gridSize()}px;
`;

const CancelDeletion = ({
  children,
  message,
}: {
  children?: React.ReactNode;
  message?: React.ReactNode;
}) => (
  <CancelDeletionContainer id="cancel-account-deletion-page">
    {message}
    {children}
  </CancelDeletionContainer>
);

export default CancelDeletion;
